import { useMemo, useState, useLayoutEffect } from "react";

export const createPromiseResolver = () => {
  let resolve;
  const promise = new Promise(r => resolve = r);
  return { resolve, promise };
};

export const useSuspense = <T>(factory: () => Promise<T>, dependencies: any[]) => {
  const resolver            = useMemo(createPromiseResolver, dependencies);
  const [ state, setState ] = useState<{ loading: boolean, value?: T }>({ loading: false });
  
  useLayoutEffect(() => {
    setState({ loading: true });
    
    factory().then(result => {
      setState({ loading: false, value: result });
      resolver.resolve();
    });
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ ...dependencies, resolver ]);

  if (state.loading)
    throw resolver.promise;
  
  return state.value;
}